import axiosInstance from './axiosInstance'

export const getInstallationVendorById = (vendorId) => {
  return axiosInstance.get(`/installation-vendors/${vendorId}`)
}

export const getInstallationVendors = (page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc') => {
  return axiosInstance.get(`/installation-vendors?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const exportInstallationVendors = ({ search = '', orderByKey = 'name', direction = 'asc' } = {}) => {
  return axiosInstance.get(`/installation-vendors/export?search=${search}&orderByKey=${orderByKey}&direction=${direction}`, { responseType: 'blob' })
}

export const createInstallationVendor = (data) => {
  return axiosInstance.post('/installation-vendors', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const updateInstallationVendor = (vendorId, data) => {
  return axiosInstance.put(`/installation-vendors/${vendorId}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const deleteInstallationVendor = (vendorId) => {
  return axiosInstance.delete(`/installation-vendors/${vendorId}`)
}

export const getInstallationVendorNoteById = (vendorId, noteId) => {
  return axiosInstance.get(`/installation-vendors/${vendorId}/notes/${noteId}`)
}

export const getInstallationVendorNotes = (vendorId, page = 1, limit = 50, search = '', orderByKey = 'createdAt', direction = 'desc') => {
  return axiosInstance.get(`/installation-vendors/${vendorId}/notes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createInstallationVendorNote = (vendorId, data) => {
  return axiosInstance.post(`/installation-vendors/${vendorId}/notes`, data)
}

export const updateInstallationVendorNote = (vendorId, noteId, data) => {
  return axiosInstance.put(`/installation-vendors/${vendorId}/notes/${noteId}`, data)
}

export const deleteInstallationVendorNote = (vendorId, noteId) => {
  return axiosInstance.delete(`/installation-vendors/${vendorId}/notes/${noteId}`)
}
